import { useQuery } from '@tanstack/react-query'
import { client } from '../lib/api-client'

export function useEvents(league: string, subAffiliate?: string) {
  return useQuery({
    queryKey: ['events', league, subAffiliate ?? null],
    queryFn: async () => {
      const response = await client.api.v1.events.$get({
        query: {
          league,
          // Sub-affiliate embed flag — the API swaps the bet-slip deep links
          // to the sub-affiliate's own per-book URLs (?aff=).
          ...(subAffiliate ? { aff: subAffiliate } : {}),
        },
      })
      if (!response.ok) {
        throw new Error('Failed to fetch events')
      }
      return response.json()
    },
    // Match the ingest cadence — backend updates Mongo every 2 minutes via
    // node-cron, so polling faster just re-fetches identical data. ±10s of
    // jitter so embeds across partner sites don't fire simultaneously every
    // 120s. React Query's refetchOnWindowFocus (default true) gives users an
    // instant refresh when they return to the tab regardless of interval.
    refetchInterval: () => 110_000 + Math.random() * 20_000,
    refetchIntervalInBackground: false,
  })
}
